exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".number {\n  position: relative;\n}\n.number .number__capitalize {\n  font-size: 0.24rem;\n  color: #545861;\n  margin: 0.2rem 0;\n  padding-left: 0.16rem;\n}\n.number .number__extra {\n  position: absolute;\n  right: 0.1rem;\n  top: 0.25rem;\n}\n.number .am-list-item.iosColor .am-input-control input:disabled {\n  color: black;\n}\n.money .number__extra {\n  left: 0.1rem;\n}\n.money input {\n  text-indent: 0.1rem;\n}\n.money .number__extra {\n  display: inline-block;\n  width: 0.2rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#1DA57A"}}!./src/component/Number/index.less
// module id = 596
// module chunks = 0